import { Button } from '@atomic/atm.button';
import styled from 'styled-components';
export const ButtonWrapperStyled = styled(Button) `
  max-width: 35%;
`;
